import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import styled from "styled-components";
import { Contrast } from "../../../types/general.types";
const { size, color, opacity } = ids || {};
export const IndicatorContainer = styled.div `
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 4px;
  height: ${size.general.ids_size_general_20x};
`;
export const StyledIndicator = styled.div `
  position: relative;
  height: ${size.general.ids_size_general_4x};
  width: ${size.general.ids_size_general_32x};
  margin: 0 ${size.general.ids_size_general_4x};
  border-radius: 10px;
  background: ${(props) => props.contrast === Contrast.dark
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_soft)
    : hexToRgba(color.action.neutral.ids_color_action_neutral_base, opacity.ids_opacity_soft)};
  :after {
    content: "";
    height: ${size.general.ids_size_general_4x};
    position: absolute;
    width: ${(props) => props.percentage}%;
    background: ${(props) => props.contrast === Contrast.dark
    ? color.contrast.ids_color_contrast_onDark
    : color.action.neutral.ids_color_action_neutral_base};
    border-radius: 10px;
  }
`;
//# sourceMappingURL=Indicator.style.js.map